module.exports = __webpack_public_path__ + "assets/img/img211.c3b18d9f.png";